import { initialScientificAnalysisImportModalState, ScientificAnalysisImportModalState } from '@/modules/scientific-analysis-module/components/scientific-analysis-import-modal/scientific-analysis-import-modal.models'
import { ScientificAnalysisService, scientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { Vue, Component, Ref } from 'vue-property-decorator'

@Component
export default class ScientificAnalysisImportModal extends Vue {
    state: ScientificAnalysisImportModalState
    service: ScientificAnalysisService = scientificAnalysisService
    static EVENT_IMPORTED:string = 'importEvent'
    @Ref() readonly scientificAnalysisImportModal!: any

    constructor() {
        super()
        this.state = initialScientificAnalysisImportModalState()
    }

    public show():void {
        this.scientificAnalysisImportModal.show()
    }

    public hide():void { this.scientificAnalysisImportModal.hide() }

    async _onImportClick():Promise<void> {
        if (this.state.file !== null) {
            this.$_updateLoading(true)
            const response = await this.$_toCallSecureLoading(this.service.importTemplate(this.state.file))
            if (response) {
                this.hide()
                this.$emit(ScientificAnalysisImportModal.EVENT_IMPORTED)
                this.$_updateLoading(false)
            }
        }
    }
}
